module.exports = __webpack_public_path__ + "img/9.71bdd6ed.png";